import { Component, computed, inject, Injector, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import type { MasterViewEngineEvent } from '@iot-platform/models/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IDetailCellRendererParams } from 'ag-grid-community';

export interface MasterDetailCustomParams {
  dispatchEvent?: (event: MasterViewEngineEvent) => void;
  rowData?: WritableSignal<any[]>;
}

export type MasterDetailCellRendererParams<T = unknown> = IDetailCellRendererParams<T> & MasterDetailCustomParams;

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ``
})
export class AbstractMasterDetailsCellComponent<T> implements ICellRendererAngularComp {
  params = signal<MasterDetailCellRendererParams<T> | null>(null);
  data = computed(() => this.params()?.data);
  rowData = computed(() => this.params()?.rowData());
  protected readonly injector: Injector = inject(Injector);
  agInit(params: MasterDetailCellRendererParams<T>): void {
    this.params.set(params);
  }

  refresh(params: MasterDetailCellRendererParams<T>): boolean {
    this.params.set(params);
    return true;
  }
}
